/**
 @since: 2020-04-06
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  url: '/api/po/qos/profiles',
  qosVlanList: [],
  qosQueueVlanList: [],
  selVlanList: [],
  qosVlanObj: {
    vlan_num: 1, // 객체 추가용 VLAN 번호
    vlan_opt: 0 // 객체 추가용 VLAN 태깅 옵션
  }
})

export const mutations = {
  initQoSQueueVlan (state) {
    state.qosVlanList = []
    state.qosQueueVlanList = []
    state.selVlanList = []
    state.qosVlanObj = {
      vlan_num: 1, // 객체 추가용 VLAN 번호
      vlan_opt: 0 // 객체 추가용 VLAN 태깅 옵션
    }
  },
  initQoSQueueVlanList (state) {
    state.qosQueueVlanList = []
  },
  initQoSVlanObj (state) {
    state.qosVlanObj = {
      vlan_num: 1,
      vlan_opt: 0
    }
  },
  getQoSVlanList (state, data) { // Vlan 좌측 테이블 조회
    state.qosVlanList = Object.freeze(data)
  },
  getQoSQueueVlanList (state, data) { // Vlan 우측 테이블 조회
    state.qosQueueVlanList = Object.freeze(data)
  },
  addQoSQueueVlan (state, data) {
    const cloneQosVlanList = _.cloneDeep(state.qosVlanList)
    const cloneQosQueueVlanList = _.cloneDeep(state.qosQueueVlanList)
    _.forEach(cloneQosVlanList, (item) => {
      if (item.vlan_id === data.vid) {
        item.qos_class_name = data.qos_class_name
        cloneQosQueueVlanList.push({
          vlan_id: item.vlan_id,
          vlan_name: item.vlan_name
        })
        return false
      }
    })
    state.qosVlanList = Object.freeze(cloneQosVlanList)
    state.qosQueueVlanList = Object.freeze(cloneQosQueueVlanList)
  },
  addQoSQueueVlanList (state, data) {
    const cloneQosVlanList = _.cloneDeep(state.qosVlanList)
    const cloneQosQueueVlanList = _.cloneDeep(state.qosQueueVlanList)

    _.forEach(data.addData.vlan_id_list, (item) => {
      let dupCheck = false
      for (const vlan of cloneQosQueueVlanList) {
        if (item.vlan_id === vlan.vlan_id) {
          dupCheck = true
          break
        }
      }
      if (!dupCheck) {
        for (const vlan of cloneQosVlanList) {
          if (item.vlan_id === vlan.vlan_id) {
            vlan.qos_class_name = data.qos_class_name
            item.vlan_name = vlan.vlan_name
            break
          }
        }
        cloneQosQueueVlanList.push({
          vlan_id: item.vlan_id,
          vlan_name: item.vlan_name
        })
      }
    })
    state.qosVlanList = Object.freeze(cloneQosVlanList)
    state.qosQueueVlanList = Object.freeze(cloneQosQueueVlanList)
  },
  addQoSVlanObj (state, data) { // Vlan 추가 팝업 추가
    const cloneQosVlanList = _.cloneDeep(state.qosVlanList)
    cloneQosVlanList.push(_.cloneDeep(data))
    state.qosVlanList = Object.freeze(cloneQosVlanList)
  },
  delQoSQueueVlan (state, data) {
    const cloneQosVlanList = _.cloneDeep(state.qosVlanList) // 좌측 테이블 데이터
    const cloneQosQueueVlanList = _.cloneDeep(state.qosQueueVlanList) // 우측 테이블 데이터
    _.forEach(data, (item) => {
      const itemIndex = _.findIndex(cloneQosQueueVlanList, {vlan_id: item.vlan_id})
      cloneQosQueueVlanList.splice(itemIndex, 1)
      for (const vlan of cloneQosVlanList) {
        if (item.vlan_id === vlan.vlan_id) {
          vlan.qos_class_name = ''
          break
        }
      }
    })
    state.qosVlanList = Object.freeze(cloneQosVlanList)
    state.qosQueueVlanList = Object.freeze(cloneQosQueueVlanList)
  },
  delQoSVlanObj (state, data) {
    const cloneQosVlanList = _.cloneDeep(state.qosVlanList)
    _.forEach(data, (item) => {
      const itemIndex = _.findIndex(cloneQosVlanList, ['vlan_id', item.vlan_id])
      cloneQosVlanList.splice(itemIndex, 1)
    })
    state.qosVlanList = Object.freeze(cloneQosVlanList)
  },
  setSelVlanList (state, data) { // Vlan
    state.selVlanList = _.cloneDeep(data)
  }
}

export const actions = {
  // Vlan 좌측 테이블 조회
  async getQoSVlanList ({ commit, state }, {pid, loadingShow = true, loadingHide = true} = {}) {
    const uri = `${state.url}/${pid}/vlans`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSVlanList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async getQoSQueueVlanList ({ commit, state }, {pid, qid, loadingShow = true, loadingHide = true} = {}) {
    const uri = `${state.url}/${pid}/queues/${qid}/vlans`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueVlanList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] Vlan 단일 추가
  async addQoSQueueVlan ({ commit, state }, {pid, vid, addData, queueName}) {
    const uri = `${state.url}/${pid}/vlans/${vid}`
    const payload = {
      vid: vid,
      qos_class_name: queueName
    }
    try {
      const data = await this.$axios.$put(uri, addData)
      return resultFactory(commit, {length: null, data: data, action: 'addQoSQueueVlan', param: payload})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] Vlan 복수 추가
  async addQoSQueueVlanList ({ commit, state }, {pid, addData, queueName}) {
    const uri = `${state.url}/${pid}/vlans`
    const payload = {
      addData: addData,
      qos_class_name: queueName
    }
    try {
      const data = await this.$axios.$put(uri, addData)
      return resultFactory(commit, {length: null, data: data, action: 'addQoSQueueVlanList', param: payload})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addQoSVlanObj ({ commit, state }, {pid}) { // Vlan 추가 팝업 추가.
    const uri = `${state.url}/${pid}/vlan/numbers`
    const payload = {
      vlan_num: state.qosVlanObj.vlan_num,
      vlan_opt: state.qosVlanObj.vlan_opt
    }
    try {
      const data = await this.$axios.$post(uri, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addQoSVlanObj', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delQoSQueueVlan ({ commit, state }, {pid, payload}) {
    let isMulty = false
    const idList = []
    const vid = payload[0].vlan_id
    let deleteItem = [{'vlan_id': vid}]
    const multyUrl = `${state.url}/${pid}/vlans`
    const singleUrl = `${state.url}/${pid}/vlans/${vid}`
    if (payload.length > 1) {
      isMulty = true
      _.forEach(payload, item => {
        idList.push({'vlan_id': item.vlan_id})
      })
      deleteItem = idList
    }
    try {
      const data = isMulty ? await this.$axios.$delete(multyUrl, {data: {vlan_id_list: idList}}, {failAlert: false})
        : await this.$axios.$delete(singleUrl)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delQoSQueueVlan', param: deleteItem})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delQoSVlanObj ({ commit, state }, pid) {
    let isMulty = false
    const idList = []
    const vid = state.selVlanList[0].vlan_id
    let deleteItem = [{'vlan_id': vid}]
    const multyUrl = `${state.url}/${pid}/vlan/numbers`
    const singleUrl = `${state.url}/${pid}/vlan/numbers/${vid}`
    if (state.selVlanList.length > 1) {
      isMulty = true
      _.forEach(state.selVlanList, (item) => {
        idList.push({'vlan_id': item.vlan_id, 'pokName': item.vlan_name})
      })
      deleteItem = idList
    }
    try {
      const data = isMulty ? await this.$axios.$delete(multyUrl, {data: {vlan_id_list: idList}}, {failAlert: false})
        : await this.$axios.$delete(singleUrl)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delQoSVlanObj', param: deleteItem})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
